import React, { useMemo, useState } from "react";

type AdSlotProps = {
  placement: "top" | "inline" | "section" | "product" | "product-secondary" | "product-tertiary" | "product-quaternary" | "product-quinary" | "product-senary" | "product-septenary" | "product-octonary" | "product-nonary" | "product-ali-express" | "product-ali-express-square" | "product-ali-express-500";
  label?: string;
  href?: string;
  imageUrl?: string;
  productTitle?: string;
  productPrice?: string;
  productOriginalPrice?: string;
  productDiscount?: string;
  headline?: string;
  detail?: string;
  bannerImageUrl?: string;
  bannerImageAlt?: string;
};

export type ProductCategory = "sports" | "home" | "kitchen" | "electronics";
export type AffiliateProduct = {
  id: string;
  category: ProductCategory;
  categoryLabel: string;
  href: string;
  imageUrl: string;
  title: string;
};

export const AMAZON_SHORTS_AFFILIATE_URL = "https://link.amazon/B05OM5Hhi";
const AMAZON_SHORTS_IMAGE_URL = "/manus-storage/amazon-running-shorts-b0fh6s9qxf_9dbb1d10.webp";
const AMAZON_SHORTS_TITLE = "شورت رياضي للجري للرجال سريع الجفاف — عبوة 3 قطع";
export const AMAZON_NIKE_AFFILIATE_URL = "https://amzn.eu/d/0ccq1gCF";
export const AMAZON_NIKE_IMAGE_URL = "/manus-storage/amazon-nike-training-top-b0d5mlqgnk_c61552f3.webp";
export const AMAZON_NIKE_TITLE = "قميص تدريب Nike رجالي — أبيض";
export const AMAZON_TRACKSUIT_AFFILIATE_URL = "https://amzn.eu/d/0eAg4Q4w";
export const AMAZON_TRACKSUIT_IMAGE_URL = "/manus-storage/amazon-lionpaul-tracksuit-b09v7h843w_90077f90.webp";
export const AMAZON_TRACKSUIT_TITLE = "طقم رياضي رجالي من قطعتين — جاكيت وبنطال";
export const AMAZON_ADIDAS_AFFILIATE_URL = "https://amzn.eu/d/04EVnLxQ";
export const AMAZON_ADIDAS_IMAGE_URL = "/manus-storage/amazon-adidas-dayready-tracksuit-b0czppgyxq_5815affd.webp";
export const AMAZON_ADIDAS_TITLE = "طقم adidas رياضي رجالي — أزرق داكن";
export const AMAZON_ADIDAS_ESSENTIAL_AFFILIATE_URL = "https://amzn.eu/d/06A1Qyoq";
export const AMAZON_ADIDAS_ESSENTIAL_IMAGE_URL = "/manus-storage/amazon-adidas-essentials-tracksuit-b08qjlqr5y_53395e0d.webp";
export const AMAZON_ADIDAS_ESSENTIAL_TITLE = "طقم adidas Essentials رياضي رجالي — أسود وأبيض";
export const AMAZON_DELONGHI_AFFILIATE_URL = "https://amzn.eu/d/0hgbCMbs";
export const AMAZON_DELONGHI_IMAGE_URL = "/manus-storage/amazon-delonghi-dinamica-plus-b0chyknh5g_160738e4.webp";
export const AMAZON_DELONGHI_TITLE = "ماكينة قهوة De'Longhi DINAMICA PLUS أوتوماتيكية بالكامل";
export const AMAZON_NUTRICOOK_AFFILIATE_URL = "https://amzn.eu/d/06u5NCTE";
export const AMAZON_NUTRICOOK_IMAGE_URL = "/manus-storage/amazon-nutricook-slim-xl-air-fryer-b0csnd4cyx_cea4da28.webp";
export const AMAZON_NUTRICOOK_TITLE = "قلاية هوائية Nutricook Slim XL سعة 7.6 لتر — 8 وظائف";
export const AMAZON_NUTRICOOK_GRILL_AFFILIATE_URL = "https://amzn.eu/d/08NGOOnQ";
export const AMAZON_NUTRICOOK_GRILL_IMAGE_URL = "/manus-storage/amazon-nutricook-smart-indoor-grill-afg960-b0bqrl7f8n_ab89b38d.webp";
export const AMAZON_NUTRICOOK_GRILL_TITLE = "شواية Nutricook ذكية 6 في 1 مع قلاية هوائية — سعة 8.5 لتر";
export const AMAZON_APPLE_WATCH_AFFILIATE_URL = "https://amzn.eu/d/0dRAfTme";
export const AMAZON_APPLE_WATCH_IMAGE_URL = "/manus-storage/amazon-apple-watch-series-11-b0fqfx56n8_58575278.webp";
export const AMAZON_APPLE_WATCH_TITLE = "Apple Watch Series 11 GPS — ساعة ذكية رياضية 42 مم";
export const AMAZON_IPHONE_AFFILIATE_URL = "https://amzn.eu/d/04Mrwc3O";
export const AMAZON_IPHONE_IMAGE_URL = "/manus-storage/amazon-apple-iphone-16-plus-b0dgj9mlbn_a243132a.webp";
export const AMAZON_IPHONE_TITLE = "Apple iPhone 16 Plus — سعة 256 جيجابايت، أسود";
export const AMAZON_BISSELL_AFFILIATE_URL = "https://amzn.eu/d/017BoPbt";
export const AMAZON_BISSELL_IMAGE_URL = "/manus-storage/amazon-bissell-crosswave-hydrosteam-3527e_a33a220e.webp";
export const AMAZON_BISSELL_TITLE = "BISSELL CrossWave HydroSteam 3527E — مكنسة وغسالة وبخار متعددة الوظائف";
export const ALIEXPRESS_URMYLADY_AFFILIATE_URL = "https://s.click.aliexpress.com/e/_c4lLQN0J";
export const ALIEXPRESS_URMYLADY_TITLE = "سوار URMYLADY للرجال — فضة 925 بتصميم أنيق";
export const ALIEXPRESS_URMYLADY_PRICE = "AED 9.76";
export const ALIEXPRESS_URMYLADY_ORIGINAL_PRICE = "AED 10.67";
export const ALIEXPRESS_URMYLADY_DISCOUNT = "خصم 9%";
export const ALIEXPRESS_SQUARE_AFFILIATE_URL = "https://s.click.aliexpress.com/e/_c3uCSZGR?bz=300*250";
export const ALIEXPRESS_SQUARE_500_AFFILIATE_URL = "https://s.click.aliexpress.com/e/_c3uXcRST?bz=500*500";

export const affiliateProducts: AffiliateProduct[] = [
  { id: "shorts", category: "sports", categoryLabel: "رياضة", href: AMAZON_SHORTS_AFFILIATE_URL, imageUrl: AMAZON_SHORTS_IMAGE_URL, title: AMAZON_SHORTS_TITLE },
  { id: "nike-top", category: "sports", categoryLabel: "رياضة", href: AMAZON_NIKE_AFFILIATE_URL, imageUrl: AMAZON_NIKE_IMAGE_URL, title: AMAZON_NIKE_TITLE },
  { id: "tracksuit", category: "sports", categoryLabel: "رياضة", href: AMAZON_TRACKSUIT_AFFILIATE_URL, imageUrl: AMAZON_TRACKSUIT_IMAGE_URL, title: AMAZON_TRACKSUIT_TITLE },
  { id: "adidas-dayready", category: "sports", categoryLabel: "رياضة", href: AMAZON_ADIDAS_AFFILIATE_URL, imageUrl: AMAZON_ADIDAS_IMAGE_URL, title: AMAZON_ADIDAS_TITLE },
  { id: "adidas-essentials", category: "sports", categoryLabel: "رياضة", href: AMAZON_ADIDAS_ESSENTIAL_AFFILIATE_URL, imageUrl: AMAZON_ADIDAS_ESSENTIAL_IMAGE_URL, title: AMAZON_ADIDAS_ESSENTIAL_TITLE },
  { id: "delonghi", category: "home", categoryLabel: "أجهزة منزلية", href: AMAZON_DELONGHI_AFFILIATE_URL, imageUrl: AMAZON_DELONGHI_IMAGE_URL, title: AMAZON_DELONGHI_TITLE },
  { id: "nutricook-air-fryer", category: "kitchen", categoryLabel: "المطبخ", href: AMAZON_NUTRICOOK_AFFILIATE_URL, imageUrl: AMAZON_NUTRICOOK_IMAGE_URL, title: AMAZON_NUTRICOOK_TITLE },
  { id: "nutricook-grill", category: "kitchen", categoryLabel: "المطبخ", href: AMAZON_NUTRICOOK_GRILL_AFFILIATE_URL, imageUrl: AMAZON_NUTRICOOK_GRILL_IMAGE_URL, title: AMAZON_NUTRICOOK_GRILL_TITLE },
  { id: "apple-watch-series-11", category: "sports", categoryLabel: "رياضة", href: AMAZON_APPLE_WATCH_AFFILIATE_URL, imageUrl: AMAZON_APPLE_WATCH_IMAGE_URL, title: AMAZON_APPLE_WATCH_TITLE },
  { id: "iphone-16-plus", category: "electronics", categoryLabel: "إلكترونيات", href: AMAZON_IPHONE_AFFILIATE_URL, imageUrl: AMAZON_IPHONE_IMAGE_URL, title: AMAZON_IPHONE_TITLE },
  { id: "bissell-crosswave-hydrosteam", category: "home", categoryLabel: "أجهزة منزلية", href: AMAZON_BISSELL_AFFILIATE_URL, imageUrl: AMAZON_BISSELL_IMAGE_URL, title: AMAZON_BISSELL_TITLE },
];

export function filterAffiliateProducts(products: AffiliateProduct[], category: "all" | ProductCategory) {
  return category === "all" ? products : products.filter((product) => product.category === category);
}

const placementLabels: Record<AdSlotProps["placement"], string> = {
  top: "مساحة إعلانية أعلى الصفحة",
  inline: "مساحة إعلانية بين الأقسام",
  section: "مساحة إعلانية داخل القسم",
  product: "عرض منتج رياضي داخل القسم",
  "product-secondary": "عرض رياضي إضافي داخل القسم",
  "product-tertiary": "عرض adidas رياضي داخل القسم",
  "product-quaternary": "عرض adidas Essentials رياضي داخل القسم",
  "product-quinary": "ماكينة قهوة De'Longhi داخل القسم",
  "product-senary": "قلاية Nutricook الهوائية داخل القسم",
  "product-septenary": "شواية Nutricook مع قلاية هوائية داخل القسم",
  "product-octonary": "Apple Watch Series 11 الرياضية داخل القسم",
  "product-nonary": "iPhone 16 Plus الإلكتروني داخل القسم",
  "product-ali-express": "عرض سوار URMYLADY من AliExpress داخل القسم",
  "product-ali-express-square": "مساحة إعلان AliExpress بمقاس 300×250 داخل القسم",
  "product-ali-express-500": "مساحة إعلان AliExpress بمقاس 500×500 في الصفحة",
};

export default function AdSlot({ placement, label, href, imageUrl, productTitle, productPrice, productOriginalPrice, productDiscount, headline, detail, bannerImageUrl, bannerImageAlt }: AdSlotProps) {
  const accessibleLabel = label ?? placementLabels[placement];
  const isProduct = Boolean(href && (imageUrl || productTitle));
  const content = (
    <>
      <span className="ad-slot-label">إعلان · رابط تابع</span>
      {isProduct ? (
        <span className="ad-slot-product-content">
          <span className="ad-slot-badge" aria-label="عرض خاص">عرض خاص</span>
          <span className="ad-slot-product-media">
            {imageUrl ? <img src={imageUrl} alt="" className="ad-slot-product-image" loading="lazy" /> : <span className="ad-slot-product-icon" aria-hidden="true">925</span>}
            <span className="ad-slot-image-detail" aria-hidden="true">تفاصيل المنتج</span>
          </span>
          <span className="ad-slot-product-copy">
            <strong className="ad-slot-copy">{productTitle ?? AMAZON_SHORTS_TITLE}</strong>
            {productPrice && <span className="ad-slot-price"><strong>{productPrice}</strong>{productOriginalPrice && <del>{productOriginalPrice}</del>}{productDiscount && <em>{productDiscount}</em>}</span>}
            <span className="ad-slot-note">عرض مختار — يفتح عند النقر فقط</span>
          </span>
        </span>
      ) : <span className="ad-slot-plain-content">{bannerImageUrl && <img src={bannerImageUrl} alt={bannerImageAlt ?? headline ?? "إعلان AliExpress"} className="ad-slot-banner-image" loading="lazy" />}<strong className="ad-slot-copy">{headline ?? "مساحة إعلانية"}</strong>{detail && <span className="ad-slot-note">{detail}</span>}</span>}
      {!isProduct && href && !detail && <span className="ad-slot-note">يفتح عند النقر فقط</span>}
    </>
  );

  return <aside className={`ad-slot ad-slot-${placement}`} aria-label={accessibleLabel} data-ad-slot={placement} data-ad-policy={href ? "static-click-only" : "static-no-redirect"}>
    {href ? <a className="ad-slot-link" href={href} target="_blank" rel="nofollow sponsored noopener noreferrer" aria-label={`${accessibleLabel} — يفتح عند النقر فقط`}>{content}</a> : <div className="ad-slot-link ad-slot-placeholder" aria-hidden="true">{content}</div>}
  </aside>;
}

export function ProductCatalog({ products = affiliateProducts }: { products?: AffiliateProduct[] }) {
  const [category, setCategory] = useState<"all" | ProductCategory>("all");
  const visibleProducts = useMemo(() => filterAffiliateProducts(products, category), [category, products]);
  return <section className="product-catalog" aria-labelledby="product-catalog-title" data-product-filter={category}>
    <div className="product-catalog-heading"><div><span className="eyebrow">اختيارات موثوقة</span><h2 id="product-catalog-title" className="section-title">تسوق حسب الفئة</h2></div><span className="product-catalog-count">{visibleProducts.length} منتجات</span></div>
    <div className="product-filter" role="group" aria-label="تصفية المنتجات">
      {([ ["all", "الكل"], ["sports", "رياضة"], ["home", "أجهزة منزلية"], ["kitchen", "المطبخ"], ["electronics", "إلكترونيات"] ] as const).map(([value, text]) => <button key={value} type="button" className={`tab ${category === value ? "active" : ""}`} aria-pressed={category === value} onClick={() => setCategory(value)}>{text}</button>)}
    </div>
    <div className="product-catalog-grid">{visibleProducts.map((product) => <AdSlot key={product.id} placement="product" href={product.href} imageUrl={product.imageUrl} productTitle={`${product.categoryLabel} · ${product.title}`} label={`إعلان ${product.categoryLabel}: ${product.title}`} />)}</div>
    {visibleProducts.length === 0 && <p className="product-catalog-empty">لا توجد منتجات في هذه الفئة حاليًا.</p>}
  </section>;
}

export { placementLabels, AMAZON_SHORTS_IMAGE_URL, AMAZON_SHORTS_TITLE };
